var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.items, function(item) {
        return _c(
          "div",
          {
            key: `cost-result-${item.id}`,
            staticClass: "rounded p-0 mb-2",
            class: _vm.serviceRowStyles(item)
          },
          [
            _c(
              "div",
              {
                staticClass: "row mx-auto",
                class: {
                  "d-flex align-items-center": !_vm.isMobile
                }
              },
              [
                _c(
                  "div",
                  {
                    class: {
                      "col-2 px-4 py-2": !_vm.isMobile,
                      "col py-2": _vm.isMobile
                    }
                  },
                  [
                    _c("p", { staticClass: "color-gray-6 font-14 mb-0 pl-2" }, [
                      _vm._v("Servicio:")
                    ]),
                    _c(
                      "p",
                      {
                        staticClass: "color-black font-16 mb-0 pl-2",
                        class:
                          _vm.isServiceDisabled(item) && !_vm.isReadOnly
                            ? "color-secondary-7"
                            : "color-black"
                      },
                      [_vm._v(" " + _vm._s(item.serviceName) + " ")]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    class: {
                      "col-1 row mx-auto px-5 py-2": !_vm.isMobile,
                      "col py-2": _vm.isMobile
                    }
                  },
                  [
                    _c("div", { class: { "col-6": !_vm.isMobile } }, [
                      _c("p", { staticClass: "color-gray-6 font-14 mb-0" }, [
                        _vm._v("Costo:")
                      ]),
                      _c(
                        "p",
                        {
                          staticClass: "font-16 mb-0",
                          class:
                            _vm.isServiceDisabled(item) && !_vm.isReadOnly
                              ? "color-secondary-7"
                              : "color-black"
                        },
                        [_vm._v(" " + _vm._s(_vm._f("money")(item.cost)) + " ")]
                      )
                    ])
                  ]
                ),
                _vm.isTherapyService(item) && item.checked
                  ? _c(
                      "div",
                      {
                        class: {
                          "col-3 row mx-auto px-5 py-2": !_vm.isMobile,
                          "col py-2": _vm.isMobile
                        }
                      },
                      [
                        _c("div", { class: { col: !_vm.isMobile } }, [
                          _c(
                            "p",
                            { staticClass: "color-gray-6 font-14 mb-0" },
                            [_vm._v("Intervenciones:")]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "font-16 mb-0",
                              class:
                                _vm.isServiceDisabled(item) && !_vm.isReadOnly
                                  ? "color-secondary-7"
                                  : "color-black"
                            },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required|min_value:1" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          !_vm.readOnly
                                            ? _c("custom-input", {
                                                attrs: {
                                                  "custom-error-msg":
                                                    "Favor completar la cantidad de intervenciones que se ofrecieron para el periodo seleccionado.",
                                                  error: errors[0],
                                                  type: "number",
                                                  value: item.visitCount
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.onVisitCountChange(
                                                      item,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm.readOnly
                                ? _c("span", [_vm._v(_vm._s(item.visitCount))])
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.isTherapyService(item) && item.checked
                  ? _c(
                      "div",
                      {
                        class: {
                          "col-2 row mx-auto px-5 py-2": !_vm.isMobile,
                          "col py-2": _vm.isMobile
                        }
                      },
                      [
                        _c("div", { class: { col: !_vm.isMobile } }, [
                          _c(
                            "p",
                            { staticClass: "color-gray-6 font-14 mb-0" },
                            [_vm._v("Costo Total:")]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "font-16 mb-0",
                              class:
                                _vm.isServiceDisabled(item) && !_vm.isReadOnly
                                  ? "color-secondary-7"
                                  : "color-black"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("money")(
                                      item.cost * item.visitCount ?? 1
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.isTherapyService(item) && item.checked
                  ? _c(
                      "div",
                      {
                        class: {
                          "col row mx-auto px-5 py-2": !_vm.isMobile,
                          "col py-2": _vm.isMobile
                        }
                      },
                      [
                        _c("div", { class: { col: !_vm.isMobile } }, [
                          item.document || _vm.isNew || _vm.isReturnToReview
                            ? _c(
                                "p",
                                { staticClass: "color-gray-6 font-14 mb-0" },
                                [_vm._v(" Certificación de Servicios: ")]
                              )
                            : _vm._e(),
                          _c(
                            "p",
                            {
                              staticClass: "font-16 mb-0",
                              class:
                                _vm.isServiceDisabled(item) && !_vm.isReadOnly
                                  ? "color-secondary-7"
                                  : "color-black"
                            },
                            [
                              !item.document &&
                              (_vm.isNew || _vm.isReturnToReview)
                                ? _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ validate, errors }) {
                                            return [
                                              !item.document
                                                ? _c("custom-file-input", {
                                                    ref: "fileUpload",
                                                    refInFor: true,
                                                    staticClass:
                                                      "custom-document-input",
                                                    attrs: {
                                                      accept: ".pdf",
                                                      "custom-error-msg":
                                                        "Documento de Certificación de Servicio es requerido para someter solicitud.",
                                                      "display-style": "normal",
                                                      error: errors[0],
                                                      label: "",
                                                      "on-download": () => {},
                                                      required: ""
                                                    },
                                                    on: {
                                                      "after-remove": function(
                                                        $event
                                                      ) {
                                                        return _vm.onServiceFileRemoved(
                                                          item
                                                        )
                                                      },
                                                      input: function($event) {
                                                        _vm.onServiceFileChange(
                                                          item,
                                                          $event
                                                        ) || validate($event)
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                : _vm._e(),
                              item.document
                                ? _c("action-button", {
                                    attrs: {
                                      i: "fas fa-download",
                                      text: "Descargar",
                                      variant: "success download-btn px-3"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onDownload(
                                          item.document.documentId
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              item.document && _vm.isReturnToReview
                                ? _c("action-button", {
                                    attrs: {
                                      i: "fas fa-undo-alt",
                                      text: "Reemplazar",
                                      variant: "outline-success ml-2"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onReplaceDocument(item.id)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _c("input", {
                                ref: `replaceDocumentHidden${item.id}`,
                                refInFor: true,
                                staticStyle: { display: "none" },
                                attrs: {
                                  id: `replaceDocumentHidden${item.id}`,
                                  accept: ".pdf",
                                  type: "file"
                                },
                                on: {
                                  change: e => _vm.onUploadReplaceFile(e, item)
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                !_vm.isReadOnly
                  ? _c(
                      "div",
                      {
                        staticClass: "check-box py-3 px-4",
                        class: _vm.checkboxStyles(item)
                      },
                      [
                        _c("check-box", {
                          staticClass:
                            "d-flex justify-content-center align-items-center p-0",
                          class: _vm.checkboxStyles(item),
                          attrs: { disabled: _vm.isServiceDisabled(item) },
                          on: {
                            input: function($event) {
                              return _vm.onSelectService({
                                id: item.id,
                                serviceId: item.serviceId,
                                checked: $event,
                                cost: item.cost
                              })
                            }
                          },
                          model: {
                            value: item.checked,
                            callback: function($$v) {
                              _vm.$set(item, "checked", $$v)
                            },
                            expression: "item.checked"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      }),
      !_vm.isReadOnly
        ? _c(
            "div",
            {
              staticClass:
                "service-total rounded bg-secondary-12 d-flex justify-content-end align-items-center px-3 py-2"
            },
            [
              _c("span", { staticClass: "color-black font-16" }, [
                _vm._v(" Monto a reembolsar para el periodo seleccionado: ")
              ]),
              _c(
                "span",
                { staticClass: "color-black font-16 font-weight-bold pl-2" },
                [_vm._v(" " + _vm._s(_vm._f("money")(_vm.totalAmount)) + " ")]
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }